import gsap from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
const headerSocket = () => {

    if(document.querySelector('.kirinus-header-socket') && document.querySelector('.kirinus-speciality-selector')){
        const theHeader = document.querySelector('.kirinus-header')
        const nav = theHeader.querySelector('.kirinus-header-socket');
        const generalMenu = theHeader.querySelector('.navbar');
        const fieldHeader = document.querySelector('.kirinus-field-header');
        const tl = gsap.timeline({
            scrollTrigger:{
                scrub: true,
                //markers: true,
                trigger: fieldHeader,
                start: 'bottom-=40 top',
                end: 'bottom-=40 top',
                //toggleActions: 'restart pause reverse reset',
                animation: tl,
            }

    });

        tl.timeScale(0.5);
        //
        tl.call(()=>{
            generalMenu.classList.add('shadow');
            generalMenu.classList.remove('no-shadow');
            nav.classList.remove('shadow');
            nav.style.opacity = '1';
        })

        tl.fromTo(nav, {yPercent: -300 }, {yPercent: 0});
        tl.call(()=>{
            generalMenu.classList.remove('shadow');
            generalMenu.classList.add('no-shadow');
            nav.classList.add('shadow');
        })



    }
}
export default headerSocket;